<script setup lang="ts">
  import BranchesService from '@/api/services/branches.service';
  import { useModal } from '@/composition/use-modal';
  import { useUi } from '@/composition/use-ui';
  import { IBranch } from '@/interfaces/IBranch';
  import { useRestaurantStore } from '@/stores/restaurant.store';
  import { ref } from 'vue';
  import { useRouter } from 'vue-router/composables';

  const props = defineProps<{
    branch: IBranch;
  }>();
  const restaurantStore = useRestaurantStore();

  const modals = useModal();
  const router = useRouter();
  const ui = useUi();

  const deleting = ref(false);
  async function deleteBranch() {
    if (deleting.value) return;

    try {
      deleting.value = true;

      const confirmed = await modals.confirm({
        title: `Eliminar sucursal ${props.branch.name}`,
        message: `¿Está seguro de que desea eliminar la sucursal ${props.branch.name}?`,
        acceptText: 'Eliminar',
        acceptColor: 'error',
      });

      if (!confirmed) return;

      await BranchesService.delete(props.branch.id);

      router.push(`/${restaurantStore.restaurant.stringId}/dashboard`);
    } catch (err) {
      ui.serverError(err, 'No se pudo eliminar la sucursal, intente de nuevo');
    } finally {
      deleting.value = false;
    }
  }
</script>

<template>
  <div class="branch-danger-zone">
    <h4 class="zone-title">Zona peligrosa</h4>
    <span class="zone-notes">Proceda con precaución</span>
    <v-btn small color="error" @click="deleteBranch" depressed>
      <v-icon left small>mdi-delete</v-icon>
      Eliminar sucursal</v-btn
    >
  </div>
</template>

<style scoped lang="scss">
  .branch-danger-zone {
    @apply tw-space-y-2 tw-flex tw-flex-col tw-items-start;

    .zone-title {
      @apply tw-text-red-600 tw-text-sm;
      line-height: 1em;
    }

    .zone-notes {
      @apply tw-text-xs tw-text-red-600;
      line-height: 1em;
    }
  }
</style>
